var _rect, _path, _g, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedicalAdvisorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 0.70293,
    width: 28.6,
    height: 28.6,
    rx: 14.3,
    fill: "#E8F5FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_672_33051",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.00293H23V23.0029H7V7.00293Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_672_33051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1701 9.02201C17.4381 8.04598 16.2893 7.47157 15.0693 7.47157H14.9287C13.7086 7.47157 12.5598 8.04598 11.8278 9.02201L11.8277 9.02213C11.6049 9.31929 11.4844 9.68066 11.4844 10.0521V11.9903C11.4844 13.9314 13.0579 15.5049 14.999 15.5049C16.94 15.5049 18.5136 13.9314 18.5136 11.9903V10.0521C18.5136 9.68066 18.3931 9.31929 18.1702 9.02213L18.1701 9.02201Z",
    stroke: "#4D4D4D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4844 11.4883H11.4844C11.8059 11.4883 12.1142 11.3606 12.3415 11.1333C12.6304 10.8443 12.9906 10.4841 12.9906 10.4841H12.9907C14.2549 11.1163 15.743 11.1163 17.0072 10.4841H17.0073C17.0073 10.4841 17.3675 10.8443 17.6565 11.1333C17.8838 11.3606 18.1921 11.4883 18.5135 11.4883H18.5136",
    stroke: "#4D4D4D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5312 22.5342C22.5312 22.5342 21.9183 20.6955 21.4745 19.3639C21.1956 18.5273 20.4983 17.8984 19.6375 17.7071C18.3092 17.4119 16.5063 17.0113 16.5063 17.0113L15 19.5217L13.4937 17.0113C13.4937 17.0113 11.6908 17.4119 10.3625 17.7071C9.50172 17.8984 8.80438 18.5273 8.5255 19.3639C8.08166 20.6955 7.46875 22.5342 7.46875 22.5342",
    stroke: "#4D4D4D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4922 17.0107V15.2437",
    stroke: "#4D4D4D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5078 17.0107V15.2437",
    stroke: "#4D4D4D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5099 22.5342H17.0078V21.0279C17.0078 20.6285 17.1665 20.2453 17.449 19.9629C17.7315 19.6804 18.1146 19.5217 18.5141 19.5217C19.3459 19.5217 20.0203 20.1961 20.0203 21.0279V22.5342H19.5183",
    stroke: "#4D4D4D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5156 19.0195V17.4575",
    stroke: "#4D4D4D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4846 20.5258C10.9304 20.5258 10.4805 20.9758 10.4805 21.53C10.4805 22.0842 10.9304 22.5342 11.4846 22.5342C12.0388 22.5342 12.4888 22.0842 12.4888 21.53C12.4888 20.9758 12.0388 20.5258 11.4846 20.5258Z",
    stroke: "#4D4D4D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4844 20.5264V17.4581",
    stroke: "#4D4D4D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 0.70293,
    width: 28.6,
    height: 28.6,
    rx: 14.3,
    stroke: "#4D4D4D",
    strokeWidth: 1.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalAdvisorIcon);
export default __webpack_public_path__ + "static/media/medical-advisor-icon.0b82a1dbbbe404104437469301c66500.svg";
export { ForwardRef as ReactComponent };